const GRAIN = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='150' height='150'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='150' height='150' filter='url(%23n)' opacity='.5'/%3E%3C/svg%3E\")";
const CARD_BG = "linear-gradient(180deg, rgba(255,255,255,0.88) 0%, rgba(255,255,255,0.86) 70%, rgba(235,243,255,0.78) 100%)";

/**
 * Carte élève — LECTURE SEULE (spec GAR §0.7) : l'identité vient de l'import
 * établissement, plus d'édition ni de suppression sur la fiche.
 */
export const StudentCard = ({ student, handleRowClick,
    getClassementEleve, listEleves, getInitials, getNbEval, calculerMoyenne, resultats, getPositionIcon }) => {

  const classement = getClassementEleve(student, listEleves);
  const isEleveGAR = student.synchronise_gar && student.eleve_gar;
  const displayNom = isEleveGAR ? student.eleve_gar_nom : student.nom;
  const displayPrenom = isEleveGAR ? student.eleve_gar_prenom : student.prenom;

  const r = resultats[student.id + student.nom + student.prenom];
  const moyenne = calculerMoyenne(student);
  const nbEval = getNbEval(student);
  const acquisPct = r && r.total > 0
    ? ((r.vertplus + r.vert) / r.total * 100).toFixed(1)
    : null;

  const barColors = [
    { key: 'vertplus', color: '#166534', value: r?.vertplus },
    { key: 'vert', color: '#22C55E', value: r?.vert },
    { key: 'teal', color: '#5EEAD4', value: r?.teal },
    { key: 'yellow', color: '#F59E0B', value: r?.yellow },
    { key: 'orange', color: '#F97316', value: r?.orange },
    { key: 'rouge', color: '#EF4444', value: r?.rouge },
  ];

  return (
    <div
      className="elv-card group"
      style={{
        background: CARD_BG,
        backdropFilter: "blur(8px)", WebkitBackdropFilter: "blur(8px)",
        borderRadius: "var(--elv-r, 18px)",
        padding: "var(--elv-pad, 20px 22px)",
        border: "1px solid rgba(255,255,255,0.65)",
        boxShadow: "0 12px 40px rgba(30,58,138,0.1), 0 4px 12px rgba(30,58,138,0.06), inset 0 1px 0 rgba(255,255,255,0.9)",
        position: "relative", overflow: "visible", cursor: "pointer",
        display: "flex", flexDirection: "column",
      }}
      onClick={() => handleRowClick(student)}
    >
      {/* Grain */}
      <div style={{
        position: "absolute", inset: 0, opacity: 0.018, pointerEvents: "none",
        borderRadius: "var(--elv-r, 18px)", overflow: "hidden",
        backgroundImage: GRAIN, mixBlendMode: "multiply",
      }} />

      {/* GAR badge */}
      {isEleveGAR && (
        <div style={{
          position: "absolute", top: 0, left: 12,
          background: "#2563EB", color: "white",
          fontSize: 10, fontWeight: 700,
          padding: "3px 8px", borderRadius: "0 0 6px 6px",
          boxShadow: "0 2px 6px rgba(37,99,235,0.3)",
        }}>GAR</div>
      )}

      {/* Content */}
      <div style={{ position: "relative", zIndex: 1, display: "flex", flexDirection: "column", flex: 1 }}>

        {/* Avatar + Name */}
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
          <div style={{
            width: "var(--elv-avatar, 42px)", height: "var(--elv-avatar, 42px)", borderRadius: "50%",
            background: "linear-gradient(135deg, #3B82F6, #06B6D4)",
            display: "flex", alignItems: "center", justifyContent: "center",
            color: "white", fontWeight: 700, fontSize: "var(--elv-avatar-fs, 15px)",
            boxShadow: "0 4px 12px rgba(59,130,246,0.25)",
            flexShrink: 0,
          }}>
            {getInitials(displayNom, displayPrenom)}
          </div>

          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: "var(--elv-name, 14px)", fontWeight: 700, color: "#1A2744", lineHeight: 1.3 }}>
              {displayPrenom} {displayNom}
            </div>
            <div style={{ fontSize: "var(--elv-meta, 11px)", color: "#9AA5BD", marginTop: 2 }}>
              {student.groupe_nom || student.classe_nom} · {nbEval} évaluation{nbEval > 1 ? 's' : ''}
            </div>
          </div>
        </div>

        {/* Stats */}
        <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
          {[
            { value: moyenne || '-', label: 'Moyenne' },
            { value: acquisPct ? `${acquisPct}%` : '-', label: 'Acquis' },
            { value: nbEval, label: 'Évals' },
          ].map((s, i) => (
            <div key={i} style={{
              flex: 1, textAlign: "center", padding: "8px 4px",
              background: "rgba(30,58,138,0.03)", borderRadius: 10,
            }}>
              <div style={{ fontSize: "var(--elv-stat, 18px)", fontWeight: 800, fontFamily: "monospace", color: "#6366F1", lineHeight: 1 }}>
                {s.value}
              </div>
              <div style={{ fontSize: "var(--elv-stat-sub, 10px)", color: "#9AA5BD", marginTop: 3, fontWeight: 500 }}>
                {s.label}
              </div>
            </div>
          ))}
        </div>

        {/* Bottom section — pushed to bottom */}
        <div style={{ marginTop: "auto" }}>

          {/* Distribution bar */}
          {r && r.total > 0 && (
            <div style={{ paddingTop: 10, borderTop: "1.5px solid rgba(30,58,138,0.08)", marginBottom: 10 }}>
              {/* Bar */}
              <div style={{ display: "flex", gap: 2, height: "var(--elv-bar, 6px)", borderRadius: 3, overflow: "hidden", background: "rgba(30,58,138,0.05)", marginBottom: 6 }}>
                {barColors.map(c => c.value > 0 ? <div key={c.key} style={{ flex: c.value, background: c.color, borderRadius: 3 }} /> : null)}
              </div>

              {/* Legend dots */}
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8, fontSize: "var(--elv-leg, 10px)", color: "#9AA5BD" }}>
                {barColors.map(c => c.value > 0 ? (
                  <span key={c.key} style={{ display: "flex", alignItems: "center", gap: 3 }}>
                    <div style={{ width: "var(--elv-dot, 7px)", height: "var(--elv-dot, 7px)", borderRadius: "50%", background: c.color, flexShrink: 0 }} />
                    {(c.value / r.total * 100).toFixed(0)}%
                  </span>
                ) : null)}
              </div>
            </div>
          )}

          {/* Ranking */}
          {classement ? (
            <div style={{
              display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
              padding: "6px 12px", borderRadius: 12,
              background: "rgba(99,102,241,0.07)", border: "1px solid rgba(99,102,241,0.12)",
              fontSize: "var(--elv-rank, 12px)", fontWeight: 600, color: "#6366F1",
            }}>
              <span>{getPositionIcon(classement.rang)}</span>
              <span>{classement.rang}e sur {listEleves.length}</span>
            </div>
          ) : (
            <div style={{
              display: "flex", alignItems: "center", justifyContent: "center",
              padding: "6px 12px", borderRadius: 12,
              background: "rgba(99,102,241,0.04)", border: "1px solid rgba(99,102,241,0.08)",
              fontSize: "var(--elv-rank, 11px)", fontWeight: 600, color: "#9AA5BD",
            }}>
              Non classé
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
